// Given a plan-cycle anchor (the date the user's monthly cycle started) and
// "now", return the next renewal date — the first anchor-plus-N-months that
// lands strictly after `now`.
//
// Uses UTC-based month math so the result is deterministic regardless of the
// runner's local timezone. For a month where the anchor's day-of-month
// doesn't exist (Jan 31 → Feb), we clamp DOWN to the last day of the target
// month (Feb 28 or 29), which matches how monthly-billing systems behave.
// Naïve `Date#setMonth(n + 1)` would silently overflow (Jan 31 → Mar 3) and
// skip a whole month — that was the bug the test suite caught.

export const computeRenewalDate = (
  anchor: Date | null | undefined,
  now: Date,
): Date | null => {
  if (!anchor) return null;

  const anchorDay = anchor.getUTCDate();
  const hh = anchor.getUTCHours();
  const mm = anchor.getUTCMinutes();
  const ss = anchor.getUTCSeconds();
  const ms = anchor.getUTCMilliseconds();

  let year = anchor.getUTCFullYear();
  let month = anchor.getUTCMonth();

  const buildCandidate = (): Date => {
    const lastDayOfMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    const day = Math.min(anchorDay, lastDayOfMonth);
    return new Date(Date.UTC(year, month, day, hh, mm, ss, ms));
  };

  let candidate = buildCandidate();
  while (candidate.getTime() <= now.getTime()) {
    month += 1;
    if (month > 11) {
      month -= 12;
      year += 1;
    }
    candidate = buildCandidate();
  }
  return candidate;
};
